import React, { useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MiButton } from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { Box, Collapse, Typography } from "@mui/material";

export const ContactsListSection = ({
  header,
  items = [],
  renderCard,
  showPrimaryToggle = true,
}) => {
  const { classes } = useStyles();
  const [showAll, setShowAll] = useState(true);

  const handleToggleView = () => setShowAll((prev) => !prev);

  const primaryItem = items.filter((item) => item.isPrimary);
  const filteredItems = showAll ? items : primaryItem;

  return (
    <Box className={classes.contactListContainer}>
      <Box className={classes.header}>
        <Typography variant="body1" color="primary.main" fontWeight={600}>
          {header}
        </Typography>
        {items.length > 1 && showPrimaryToggle && (
          <MiButton
            onClick={handleToggleView}
            title={
              <div>
                <Collapse in={showAll} timeout={400}>
                  <span>Primary only</span>
                </Collapse>
                <Collapse in={!showAll} timeout={400}>
                  <span>View all</span>
                </Collapse>
              </div>
            }
            className={classes.toggleButton}
            variant={BUTTON_VARIANTS.TEXT}
            disableRipple
          />
        )}
      </Box>
      <Box className={classes.cardsGrid}>
        {filteredItems.map((item, index) => (
          <React.Fragment key={`${item.resourceId}-${index}`}>
            {renderCard(item)}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  toggleButton: {
    color: theme.palette.grey.medium,
    marginRight: theme.spacing(2),
    textDecoration: "underline",
    padding: 0,
    minWidth: "unset",
    "&:hover": {
      background: "none",
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  cardsGrid: {
    display: "grid",
    gridTemplateColumns: `repeat(auto-fit, minmax(max(330px, 48%), 1fr))`,
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
}));
